import axios from "axios";
import type { HeadBaseApiModel } from "../../api-models";

async function getSoloHeadModel(headId: string): Promise<HeadBaseApiModel | null> {
  return (await axios.get(`/api/head/mysolo/${headId}`)).data;
}

async function getViewpointsHeadModel(headId: string): Promise<HeadBaseApiModel | null> {
  return (await axios.get(`/api/head/myviewpoints/${headId}`)).data;
}

async function getTeamSoloHeadModel(headId: string): Promise<HeadBaseApiModel | null> {
  return (await axios.get(`/api/head/teamsolo/${headId}`)).data;
}

async function getTeamViewpointsHeadModel(headId: string): Promise<HeadBaseApiModel | null> {
  return (await axios.get(`/api/head/teamviewpoints/${headId}`)).data;
}

async function getOrgSoloHeadModel(headId: string): Promise<HeadBaseApiModel | null> {
  return (await axios.get(`/api/head/orgsolo/${headId}`)).data;
}

async function getOrgViewpointsHeadModel(headId: string): Promise<HeadBaseApiModel | null> {
  return (await axios.get(`/api/head/orgviewpoints/${headId}`)).data;
}

async function getTeamEffectivenessIndividualHeadModel(
  headId: string,
): Promise<HeadBaseApiModel | null> {
  return (await axios.get(`/api/head/teameffectivenessindividual/${headId}`)).data;
}

async function getTeamEffectivenessAggregateHeadModel(
  headId: string,
  sharedCode?: string,
): Promise<HeadBaseApiModel | null> {
  const url =
    sharedCode == null
      ? `/api/head/teameffectivenessaggregate/${headId}`
      : `/api/head/teameffectivenessaggregate/${headId}?sharedcode=${sharedCode}`;
  return (await axios.get(url)).data;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useHeadModel() {
  return {
    getSoloHeadModel,
    getViewpointsHeadModel,
    getTeamSoloHeadModel,
    getTeamViewpointsHeadModel,
    getOrgSoloHeadModel,
    getOrgViewpointsHeadModel,
    getTeamEffectivenessIndividualHeadModel,
    getTeamEffectivenessAggregateHeadModel,
  };
}
